import Image from "next/image";
import Link from "next/link";
import FeatherIconCom from "CommonElements/Icons/FeatherIconCom";
import React, { useEffect, useState } from "react";
import { Admin, EmayWalter, Href } from "utils/Constant";
import { profileListData } from "Data/HeaderData";
import { Logout } from "../../../../utils/Constant/index";
import { useRouter } from "next/router";
import Cookies from "js-cookie";
import { useUserData } from "helper/UserData";
import { UserGroups } from "Types/OSM/User";
import { HttpBuildQuery } from "@/lib/http";
import { OSMtoMenu } from "@/lib/osm";
import { sidebarMenuType } from "Types/LayoutDataType copy";
import { toast } from "react-toastify";
import { decryptData } from "@/lib/crypto";

const Profile = () => {
  const router = useRouter();
  const { userApps, isLoading, userData } = useUserData();
  const [jabatan, setJabatan] = useState<string | null>(null);

  useEffect(() => {
    if (!userData?.id) return;
    fetch("/api/doServices", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        method: "GET",
        endpoint: `kepegawaian/pegawai/detail/${userData.id}`,
        isForm: false,
        isImage: false,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.http_code === 200 && result.data) {
          const j = result.data.jabatan_tambahan || result.data.jabatan_akhir || "";
          setJabatan(j.trim() || null);
        }
      })
      .catch(() => { });
  }, [userData?.id]);

  const handleLogOut = (e: any) => {
    e.preventDefault();
    Cookies.remove('osm_sess', {
      path: "/",
      domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN
    });
    router.push("/authentication/login");
  };


  const getMenu = async (id: number): Promise<sidebarMenuType[]> => {
    const queryParam = {
      limit: 300,
      page: 1,
      group_id: id,
      order: "urutan"
    }

    const queryString = HttpBuildQuery(queryParam);

    const response = await fetch('/api/doServices', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        method: 'GET',
        endpoint: `office/modul/nested?${queryString}`,
        isForm: false,
        isImage: false,
      }),
    });

    if (response.status !== 200) {
      return [];
    }

    const result = await response.json();

    const mappingMenu = OSMtoMenu(result.data)
    return [
      {
        title: "OFFICE",
        menucontent: "OFFICE",
        Items: mappingMenu,
      },
    ];
  }

  const getSession = async (): Promise<any | null> => {
    const sessionId = Cookies.get("osm_sess");
    if (!sessionId) return null;
    const response = await fetch('/api/session/get', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(sessionId),
    });

    if (response.ok) {
      const encryptedData = await response.json();
      const decryptedUserData = decryptData(encryptedData);
      return decryptedUserData;
    } else {
      console.error('Failed to fetch user data');
      return null;
    }
  }

  const checkGroup = async (userID: number, groupID: number): Promise<boolean> => {
    const response = await fetch('/api/doServices', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        method: 'GET',
        endpoint: `users/${userID}/groups/${groupID}`,
        isForm: false,
        isImage: false,
      }),
    });

    if (response.status !== 200) {
      return false;
    }

    const result = await response.json();

    if (result.http_code === 200 && result.data) {
      return true;
    }
    return false;
  }

  const changeMenu = async (groupId: number, id: number) => {
    try {
      const API_KEY = process.env.NEXT_PUBLIC_API_KEY as string;
      const sessionData: any = await getSession();

      const userId = sessionData?.[API_KEY]?.users_id;
      if (!userId) {
        toast.error('Sesi pengguna tidak valid.');
        return;
      }


      // 1) Check access first; exit early if false
      const hasAccess = await checkGroup(userId, groupId);
      if (!hasAccess) {
        toast.error('Gagal Ubah Grup, user tidak memiliki akses ke grup tersebut');
        return;
      }

      // 2) Only reach here if user has access
      const selectedGroup = sessionData[API_KEY].listGroup.find(
        (g: any) => g.id === id || g.groups_id === groupId
      );
      const menu = await getMenu(groupId);
      sessionData[API_KEY].group = selectedGroup.groups_nama;
      sessionData[API_KEY].listMenu = menu;

      const saveRes = await fetch('/api/session/set', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(sessionData),
      });

      if (saveRes.ok) {
        const { sessionId } = await saveRes.json();
        Cookies.set('osm_sess', sessionId, {
          expires: 1,
          path: "/",
          domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN
        });
        toast.success('Sukses Ubah Grup');
        window.location.reload();
      } else {
        toast.error('Gagal menyimpan sesi setelah ubah grup.');
      }
    } catch (err) {
      console.error('changeMenu error:', err);
      toast.error('Terjadi kesalahan saat mengubah grup.');
    }
  };

  return (
    <li className="profile-nav onhover-dropdown pe-0 py-0">
      <div className="media profile-media">
        <Image className="b-r-10" src="/assets/images/dashboard/profile.png" alt="" width={35} height={35} />
        <div className="media-body">
          <span>{userData?.name ?? "User"}</span>
          <p className="mb-0 font-roboto">
            {jabatan ?? "-"} <i className="middle fa fa-angle-down" />
          </p>
        </div>
      </div>
      <ul className="profile-dropdown onhover-show-div">
        {userData && userData.listGroup && userData.listGroup.length >= 1 && (
          <>
            <li className="px-3 pt-2 pb-1">
              <small className="text-muted fw-semibold" style={{ fontSize: "0.7rem", letterSpacing: "0.05em" }}>
                GANTI GROUP
              </small>
            </li>
            {userData.listGroup.map((item: UserGroups, index: number) => (
              <li key={index}>
                <button
                  type="button"
                  onClick={() => changeMenu(item.groups_id, item.id)}
                  className="btn p-0 d-flex align-items-center"
                  style={item.groups_nama === userData.group ? { fontWeight: 600 } : {}}
                >
                  <FeatherIconCom iconName={"LogIn"} />
                  <span>{item.groups_nama}</span>
                </button>
              </li>
            ))}
            <li><hr className="dropdown-divider my-1" /></li>
          </>
        )}
        <li>
          <button type="button" onClick={handleLogOut} className="btn btn-link p-0 d-flex align-items-center">
            <FeatherIconCom iconName={"LogOut"} />
            <span>{Logout}</span>
          </button>
        </li>
      </ul>
    </li>
  );
};

export default Profile;
